import { c as _c } from "react/compiler-runtime";
import { AnimationEvent, useState } from 'react';
import { Resolutions } from '@spa/lib/const';
import { useMediaQuery } from 'usehooks-ts';
export interface StickyBuyRowVisibility {
  readonly isRendered: boolean;
  readonly onAnimationEnd: (event: AnimationEvent<HTMLDivElement>) => void;
}
export function useStickyBuyRowVisibility(isVisible) {
  const $ = _c(7);
  const [isRendered, setIsRendered] = useState(isVisible);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      initializeWithValue: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      initializeWithValue: false
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isTabletUp = useMediaQuery(`(min-width: ${Resolutions.LARGE}px)`, t1);
  const isAnimated = isTabletUp && !prefersReducedMotion;
  if (isVisible && !isRendered) {
    setIsRendered(true);
  }
  if (!isVisible && isRendered && !isAnimated) {
    setIsRendered(false);
  }
  let t2;
  if ($[2] !== isVisible) {
    t2 = event => {
      if (event.target === event.currentTarget && !isVisible) {
        setIsRendered(false);
      }
    };
    $[2] = isVisible;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onAnimationEnd = t2;
  let t3;
  if ($[4] !== isRendered || $[5] !== onAnimationEnd) {
    t3 = {
      isRendered,
      onAnimationEnd
    };
    $[4] = isRendered;
    $[5] = onAnimationEnd;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}